import { z } from "zod";

export const AdminSettingValueSchema = z.union([
    z.string(),
    z.number(),
    z.boolean(),
    z.array(z.unknown()),
    z.record(z.string(), z.unknown()),
]);

const AdminSettingBaseSchema = z.object({
    key: z.string().min(1),
    title: z.string().min(1),
    description: z.string(),
    group: z.string().min(1),
    updated_at: z.string(),
});

export const AdminSettingSchema = z.discriminatedUnion("type", [
    AdminSettingBaseSchema.extend({
        type: z.literal("string"),
        value: z.string(),
    }),
    AdminSettingBaseSchema.extend({
        type: z.literal("text"),
        value: z.string(),
    }),
    AdminSettingBaseSchema.extend({
        type: z.literal("integer"),
        value: z.number().int(),
    }),
    AdminSettingBaseSchema.extend({
        type: z.literal("float"),
        value: z.number(),
    }),
    AdminSettingBaseSchema.extend({
        type: z.literal("boolean"),
        value: z.boolean(),
    }),
    AdminSettingBaseSchema.extend({
        type: z.literal("array"),
        value: z.array(z.unknown()),
    }),
    AdminSettingBaseSchema.extend({
        type: z.literal("object"),
        value: z.record(z.string(), z.unknown()),
    }),
]);

export const UpdateAdminSettingsRequestSchema = z.object({
    settings: z.array(z.object({
        key: z.string().min(1),
        value: AdminSettingValueSchema,
    })).min(1),
});

export type AdminSetting = z.infer<typeof AdminSettingSchema>;
export type AdminSettingType = AdminSetting["type"];
export type AdminSettingValue = z.infer<typeof AdminSettingValueSchema>;
export type UpdateAdminSettingsRequest = z.input<typeof UpdateAdminSettingsRequestSchema>;
